import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.module.scss';

const Input = ({ icon, iconClick, className, ...props }) => (
  <div className={`${styles.inputContainer} ${className}`}>
    <input {...props} />
    {icon && (
      <FontAwesomeIcon className={iconClick ? styles.clickable : ''} onClick={iconClick} icon={icon} />
    )}
  </div>
);

export default Input;
